import { render, staticRenderFns } from "./CreateAgent.vue?vue&type=template&id=cc535586"
import script from "./CreateAgent.vue?vue&type=script&lang=js"
export * from "./CreateAgent.vue?vue&type=script&lang=js"
import style0 from "./CreateAgent.vue?vue&type=style&index=0&id=cc535586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VCol,VRow,VTextField})
